import { Route, Routes } from 'react-router'

import { NotFound } from 'js/core/NotFound'

import Search from './Search'

const Component = () => (
    <Routes>
        <Route index element={<Search />} />
        <Route path="*" element={<NotFound />} />
    </Routes>
)

export default Component
